import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { isBlank } from "@/utils"
import {
  getSectionFieldNames,
  countIncompleteRequiredFields,
  getField,
  getSectionChat,
  getSettings,
  countChangedFields,
} from "@/onboarding/features/product/selectors"
import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"

import SectionHolder from "./shared/SectionHolder"
import Overview from "./tour_itinerary/Overview"
import Timeline from "./tour_itinerary/Timeline"

const TourItinerary: FC = () => {
  const fieldNames = useSelector(getSectionFieldNames.tourLocation)
  const { tour_stops } = useSelector(getSettings(ReservedFields.TOUR_STOPS))

  const tourStopsField = useSelector(getField(ReservedFields.TOUR_STOPS))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("tourStops")))

  const incompleteFieldCount = useSelector((state) => {
    const baseCount = countIncompleteRequiredFields(...fieldNames)(state)

    return isBlank(tourStopsField.value) && tourStopsField.required ? baseCount + 1 : baseCount
  })

  const proposedChangesCount = useSelector((state) => {
    const baseCount = countChangedFields(...fieldNames)(state)

    return tour_stops.changed ? baseCount + 1 : baseCount
  })

  return (
    <SectionHolder
      title="Tour Itinerary"
      name={ReservedSections.TOUR_STOPS}
      incompleteRequiredFieldCount={incompleteFieldCount}
      chat={sectionChat}
      proposedChangesCount={proposedChangesCount}
      changedComponent={tour_stops.changed}
    >
      <div className="d-flex flex-column gap-2">
        <Overview />
        <Timeline
          requiredField={tourStopsField.required}
          incompleteField={isBlank(tourStopsField.value)}
          previousStops={tour_stops.previousValue}
        />
      </div>
    </SectionHolder>
  )
}
export default TourItinerary
